import ComingSoon from "@/components/custom/coming-soon";
const SettlementPage = () => <ComingSoon label="Settlement" />;
export default SettlementPage;